export default {
  accountInfo: {},
  logged: false,
  language: {},
};
